module.exports = __webpack_public_path__ + "static/media/Tube.42d7cb1b.jpg";